var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#f7f8fa",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.943 9.943)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#768092",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x2: 9.24,
    y2: 9.24,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#768092",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x1: 9.24,
    y2: 9.24,
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1b29688387f583104a8a59c1cd12dfaa.svg";
export { ForwardRef as ReactComponent };